module.exports = __webpack_public_path__ + "static/media/cardbg.18d7e840.png";